import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

import Home from '../views/Home.vue'
import Company from '../views/Company.vue'
import ProdKanbanTV from '../views/kanban/ProdKanbanTV.vue'
import QyKanbanTV from '../views/kanban/QyKanbanTV.vue'
import MoldKanbanTV from '../views/kanban/MoldKanbanTV.vue'
import OutStockKanbanTV from '../views/kanban/OutStockKanbanTV.vue'
import ProductStockKanbanTV from '../views/kanban/ProductStockKanbanTV.vue'
import OeeTV from '../views/kanban/OeeTV.vue'

import ChkWorkTV from '../views/system/ChkWorkTV.vue'

import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Index',
    component: Index
}, {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [{
        path: '/hello',
        component: () => import('../views/Hello.vue')
    }, {
        path: '/productionKanban',
        component: () => import('../views/kanban/ProductionKanban.vue')
    }, {
        path: '/qualityKanban',
        component: () => import('../views/kanban/QualityKanban.vue')
    },{
        path: '/oEE',
        component: () => import('../views/kanban/OEE.vue')
    }, {
        path: '/productTypeBase',
        component: () => import('../views/base/ProductTypeBase.vue')
    },  {
        path: '/productBaseInfo',
        component: () => import('../views/base/ProductBaseInfo.vue')
    }, {
        path: '/customerBase',
        component: () => import('../views/base/CustomerBase.vue')
    }, {
        path: '/firstInspectionBase',
        component: () => import('../views/base/FirstInspectionBase.vue')
    },{
        path: '/processBase',
        component: () => import('../views/base/ProcessBase.vue')
    },{
        path: '/store',
        component: () => import('../views/base/Store.vue')
    }, {
        path: '/placeOrder',
        component: () => import('../views/order/PlaceOrder.vue')
    },  {
        path: '/plasticOrder',
        component: () => import('../views/order/PlasticOrder.vue')
    },{
        path: '/manufactureOrder',
        component: () => import('../views/order/ManufactureOrder.vue')
    }, {
        path: '/moldPrepare',
        component: () => import('../views/order/MoldPrepare.vue')
    }, {
        path: '/equipmentManage',
        component: () => import('../views/production/EquipmentManage.vue')
    },{
        path: '/moldRepair',
        component: () => import('../views/production/MoldRepair.vue')
    },  {
        path: '/orderLineUp',
        component: () => import('../views/production/OrderLineUp.vue')
    }, {
        path: '/workshop',
        component: () => import('../views/production/Workshop.vue')
    }, {
        path: '/patrolPoint',
        component: () => import('../views/quality/PatrolPoint.vue')
    }, {
        path: '/patrolRecord',
        component: () => import('../views/quality/PatrolRecord.vue')
    }, {
        path: '/patrolStatistic',
        component: () => import('../views/quality/PatrolStatistic.vue')
    }, {
        path: '/reckonNumberRecord',
        component: () => import('../views/quantity/ReckonNumberRecord.vue')
    }, {
        path: '/reckonStatistic',
        component: () => import('../views/quantity/ReckonStatistic.vue')
    }, {
        path: '/operationRecord',
        component: () => import('../views/report/OperationRecord.vue')
    }, {
        path: '/orderInspection',
        component: () => import('../views/report/OrderInspection.vue')
    },{
        path: '/changeProdStatistic',
        component: () => import('../views/report/ChangeProdStatistic.vue')
    },{
        path: '/checkWorkStatistic',
        component: () => import('../views/report/CheckWorkStatistic.vue')
    },{
        path: '/productInfoRecord',
        component: () => import('../views/report/ProductInfoRecord.vue')
    }, {
        path: '/productStock',
        component: () => import('../views/warehouse/ProductStock.vue')
    }, {
        path: '/inStock',
        component: () => import('../views/warehouse/InStock.vue')
    }, {
        path: '/outStock',
        component: () => import('../views/warehouse/OutStock.vue')
    }, {
        path: '/inventoryCheck',
        component: () => import('../views/warehouse/InventoryCheck.vue')
    }, {
        path: '/companyInfo',
        component: () => import('../views/system/CompanyInfo.vue')
    }, {
        path: '/workSchedule',
        component: () => import('../views/system/WorkSchedule.vue')
    },{
        path: '/chkWork',
        component: () => import('../views/system/ChkWork.vue')
    }, {
        path: '/department',
        component: () => import('../views/system/Department.vue')
    }, {
        path: '/employee',
        component: () => import('../views/user/Employee.vue')
    }, {
        path: '/role',
        component: () => import('../views/system/Role.vue')
    }, {
        path: '/printSetUp',
        component: () => import('../views/system/PrintSetUp.vue')
    }]
}, {
    path: '/Login',
    name: 'Login',
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: {
        title: '登录'
    }
}, {
    path: '/Company',
    name: 'Company',
    component: Company
}, {
    path: '/pkb',
    name: 'ProdKanbanTV',
    component: ProdKanbanTV
}, {
    path: '/qkb',
    name: 'QyKanbanTV',
    component: QyKanbanTV
},{
    path: '/mkb',
    name: 'MoldKanbanTV',
    component: MoldKanbanTV
},{
    path: '/ckb',
    name: 'ChkWorkTV',
    component: ChkWorkTV
},{
    path: '/oskb',
    name: 'OutStockKanbanTV',
    component: OutStockKanbanTV
},{
    path: '/pskb',
    name: 'ProductStockKanbanTV',
    component: ProductStockKanbanTV
},{
    path: '/oekb',
    name: 'OeeTV',
    component: OeeTV
}, {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    children: [{
        path: 'hello',
        component: () => import('../views/Hello.vue'),
        meta: {
            title: '极光注塑-开发运营系统'
        },
    }, {
        path: 'tenantAdmin',
        component: () => import('../views/TenantAdmin.vue')
    }, {
        path: 'userAdmin',
        component: () => import('../views/UserAdmin.vue')
    }, {
        path: 'tmplAdmin',
        component: () => import('../views/TmplAdmin.vue')
    }]
}
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router